import {Component, OnInit, ViewChild} from '@angular/core';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Group} from 'shared/models/target-groups/group';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {GroupsService} from './services/groups.service';

@Component({
  selector: 'groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css'],
})

export class GroupsComponent implements OnInit {
  public allGroups: Array<Group> = [];
  public filteredGroups: Array<Group>;
  public fieldsToSearch: Array<Array<String>> = [];
  public newGroupName: String;
  public searchTerm: String;
  public currentPage: Event;
  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private groupsService: GroupsService) { }

  public ngOnInit(): void {
    this.getAllGroups();
  }

  private showDeleteModal(id: number): void {
    const content: string = `Sind Sie wirklich sicher, dass Sie diese Gruppe löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  public getAllGroups(): void {
    this.groupsService.getAllGroups()
      .subscribe((allGroups: Array<Group>) => {
        this.allGroups = allGroups;
        this.filteredGroups = allGroups;
        this.prepareFieldsToSearch();
      });
  }

  public createGroup(): void {
    this.groupsService.createGroup(this.newGroupName)
      .subscribe((createdGroup) => {
        this.getAllGroups();
      });
  }

  public updateGroup(group: Group): void {
    this.groupsService.updateGroup(group)
      .subscribe((updatedGroup: Group) => {
        this.getAllGroups();
      });
  }

  public deleteGroup(group: Group): void {
    this.groupsService.deleteGroup(group)
      .subscribe((response) => {
        this.getAllGroups();
      });
  }

  public filterGroups(eventGroups: Array<Group>): void {
    this.filteredGroups = eventGroups;
  }

  private prepareFieldsToSearch(): void {
    this.allGroups.forEach((group: Group) => {
      this.fieldsToSearch.push([
        group.name.toLocaleLowerCase(),
      ]);
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/groups/groups.component.ts